<nav *ngIf="!(enableAdminOptions$ | async)" class="navbar-bg navbar navbar-expand px-4"
	style="background-color: #00000030">
	<i (click)="collapse()" aria-hidden="true" id="collapseMenu" class="fa fa-bars fa-2x text-white"></i>
</nav>
<nav *ngIf="enableAdminOptions$ | async" class="navbar navbar px-4" style="background-color: #00000030">
	<i (click)="collapse()" aria-hidden="true" id="collapseMenu" class="fa fa-bars fa-2x text-white"></i>

	<div class="ml-auto" href="#">
		<!-- <kendo-dropdownbutton
			[data]="organizationList$ | async"
			[textField]="'organizationName'"
			[popupSettings]="{ animate: true, align: 'right' }"
			(itemClick)="onOrganizationClick($event)"
		>
			{{ organization$ | async }}
			<ng-template kendoDropDownButtonItemTemplate let-dataItem>
				<span *ngIf="(scopeId$ | async) == dataItem.organizationCode" class="k-icon k-i-check"></span>
				<span *ngIf="(scopeId$ | async) !== dataItem.organizationCode" class="k-icon"></span>
				<span>{{ dataItem.organizationName }}</span>
			</ng-template>
		</kendo-dropdownbutton> -->
	</div>
</nav>
<nav *ngIf="(isAdminMenu$ | async) && (enableAdminOptions$ | async)"
	class="navbar navbar justify-content-start px-4 bg-white py-3">
	<kendo-combobox [style.max-width.px]="390" [data]="adminOrganizationList$ | async" valueField="organizationCode"
		textField="organizationName" (valueChange)="organizationService.changeOrganization($event)"
		[value]="adminSelectedOrganization$ | async" class="me-4"></kendo-combobox>
	<kendo-combobox *ngIf="organizationService.isGroupSelection" [disabled]="
			(adminSelectedOrganizationGroups$ | async).length === 1 || !(adminSelectedOrganization$ | async).organizationCode
		" [style.max-width.px]="390" [data]="adminSelectedOrganizationGroups$ | async" valueField="groupCode"
		textField="groupDescription" (valueChange)="organizationService.changeGroup($event)"
		[value]="adminSelectedGroup$ | async"></kendo-combobox>
</nav>